import { AuthResult, INativeAppState } from 'nativeAppShim';

export enum NativeDialogArea {
  RecommendationDialog,
  AddIdentity,
  RemoveIdentity,
  VerifyIdentity,
  UndoDialog,
  RemoveSubscription,
  OnboardFamilyMember,
  BulkAdd,
  CreditAlertDialog,
  CreditReportDetails,
}

export interface IWebViewState {
  initComplete: boolean;
  nativeAppState: INativeAppState | undefined;
  nativeDialogArea: NativeDialogArea | undefined;
  dialogClosing: boolean;
  isWebViewRendered: boolean;
  // Used to re-render WebView dialogs as WebView dialog doesn't get unmounted when cached
  componentKey: number;
  isPreviousDialog: boolean;
  authResult: AuthResult | undefined;
}

export function getDefaultWebViewState(): IWebViewState {
  return {
    initComplete: false,
    nativeAppState: undefined,
    nativeDialogArea: undefined,
    dialogClosing: false,
    isWebViewRendered: false,
    componentKey: 0,
    isPreviousDialog: false,
    authResult: undefined,
  };
}
